import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Fees = () => {
 return (
 <div className="fees-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">Fees</h1>
 <p className="page-subtitle">
 Premium positioning. Depth over scale.
 </p>
 </div>
 </section>

 <section className="fees-intro-section">
 <div className="section-container">
 <p className="intro-text">
 Nova Roots is a premium, fee-paying school. The fees reflect the depth of care, quality of 
 educators, small cohort sizes, and intentional design that make this model possible.
 </p>
 </div>
 </section>

 <section className="investment-section">
 <div className="section-container">
 <h2 className="section-title">What You're Investing In</h2>
 <div className="investment-grid">
 <Card className="investment-card">
 <CardContent>
 <h3>Exceptional Walezi</h3>
 <p>
 Highly trained educators who know each child deeply, track mastery carefully, and guide 
 with wisdom and care.
 </p>
 </CardContent>
 </Card>

 <Card className="investment-card">
 <CardContent>
 <h3>Small Cohorts</h3>
 <p>
 Limited enrolment ensures every child is seen, heard, and supported. No one gets lost.
 </p>
 </CardContent>
 </Card>

 <Card className="investment-card">
 <CardContent>
 <h3>Personalised Learning Systems</h3>
 <p>
 Technology that tracks progress, identifies needs, and supports mastery—without replacing 
 human judgment.
 </p>
 </CardContent>
 </Card>

 <Card className="investment-card">
 <CardContent>
 <h3>Real-World Learning</h3>
 <p>
 Access to agriculture, craft, trade, and entrepreneurship experiences that prepare children 
 for real life.
 </p>
 </CardContent>
 </Card>

 <Card className="investment-card">
 <CardContent>
 <h3>Thoughtfully Designed Environment</h3>
 <p>
 Calm, communal, African-rooted spaces that support focus, collaboration, and connection to land.
 </p>
 </CardContent>
 </Card>

 <Card className="investment-card">
 <CardContent>
 <h3>Ongoing Innovation</h3>
 <p>
 A commitment to continuous improvement, research-informed practice, and refining what works.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="philosophy-section">
 <div className="section-container">
 <div className="philosophy-box">
 <h2>Quality Over Volume</h2>
 <p>
 Nova Roots is not trying to serve everyone. We're building a model that works—one that prioritises 
 depth, care, and results over growth and scale.
 </p>
 <p>
 The fees make that possible. They ensure Walezi are supported, resources are excellent, and every 
 child receives the attention they deserve.
 </p>
 </div>
 </div>
 </section>

 <section className="details-section">
 <div className="section-container">
 <Card className="details-card">
 <CardContent className="details-content">
 <h2>Fee Structure</h2>
 <p>
 Full fee details are shared during the admissions conversation. This allows us to discuss your 
 family's specific situation, answer questions thoroughly, and ensure transparency.
 </p>
 <p>
 We believe fee conversations should be personal, not transactional. If you're interested in Nova 
 Roots, we'll provide complete information at the right time.
 </p>
 </CardContent>
 </Card>
 </div>
 </section>

 <section className="values-section">
 <div className="section-container">
 <div className="values-box">
 <h3>Our Commitment</h3>
 <p>
 Nova Roots is values-driven, not profit-driven. Every fee decision is made in service of educational 
 quality, child wellbeing, and long-term sustainability.
 </p>
 <p>
 We charge what's necessary to do this work well—no more, no less.
 </p>
 </div>
 </div>
 </section>

 <section className="cta-section">
 <div className="section-container">
 <div className="cta-box">
 <h2>Let's Talk</h2>
 <p>
 If you're interested in learning more about fees, structure, and what Nova Roots offers, we'd be 
 happy to have that conversation.
 </p>
 <Link to="/contact">
 <Button className="cta-button">
 Register Interest <ArrowRight className="ml-2" size={18} />
 </Button>
 </Link>
 </div>
 </div>
 </section>
 </div>
 );
};

export default Fees;